module.exports = __webpack_public_path__ + "static/img/img_0715.cbabba4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/portfolio/img_0715.jpg
// module id = Pj02
// module chunks = 0